import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import React from 'react';
import { useQueryClient } from 'react-query';
import { useTranslation } from "react-i18next";
import { customAlert, notify } from '../../../components/notify';
import FillLabelTxtField from '../../../components/FillLabelTxtField';
import { putZoneAddress } from '../../../services/cust-service';
import { useAuthContext } from '../../../context/AuthContext';


function EditZoneAddress({ modalOpen, handleModalClose, zone }) {

    const queryClient = useQueryClient();
    const { t } = useTranslation();
    let txtFielProps = { fontSize: 14, height: 38, width: 400 };
    const { setLoadingScreen } = useAuthContext();


    async function handleSubmit(e) {
        setLoadingScreen(true);
        try {
            e.preventDefault();
            const formData = new FormData(e.target);
            const inputObject = Object.fromEntries(formData);

            await putZoneAddress({ zoneId: zone.id, address: inputObject.address?.trim() });
            queryClient.invalidateQueries();
            handleModalClose()
            notify("success", "Zone address updated successfully")
        } catch (error) {
            customAlert(error);
        }
        setLoadingScreen(false);
    }


    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Typography variant='h5' sx={{ fontWeight: "bold", mb: 2 }}>{t("sa.rateCalc.updateZoneAddr")}</Typography>
                    <Stack gap={2} alignItems="center">
                        <FillLabelTxtField name="zone" title={t("sa.rateCalc.zone")} disabled={true} defaultValue={zone.zone} {...txtFielProps} />
                        <FillLabelTxtField multiline={true} rows={3} name="address" title={t("sa.rateCalc.address")} defaultValue={zone.address || ""} maxLength={500} {...txtFielProps} height={90} />
                        <Typography sx={{ fontSize: 12, color: "rgba(131, 146, 171, 1)", width: 400 }}>{t("sa.rateCalc.zoneAddrNote")}</Typography>

                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={400}>
                            <Button variant="text" sx={{ height: 40, width: 120 }} onClick={handleModalClose}>{t("sa.rateCalc.cancel")}</Button>
                            <Button variant="contained" type='submit' sx={{ height: 40, width: 150 }}>{t("sa.rateCalc.save")}</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form>
        </Modal>
    )
}

export default EditZoneAddress;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2,
};
